const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://mbraokkmih.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://dbbuchp8zj.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.staging.evolution.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.evolution.forwoodsafety.com',
    WEBSOCKET: 'wss://gyaxuutzbl.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;
